<template>
  <div>
    <base-header class="pb-6 pb-7 bg-gradient-success"></base-header>
    <survey-creator :elements="survey.elements" :id="survey.id" v-if="Object.keys(survey).length"></survey-creator>
  </div>
</template>

<script>

import BaseHeader from "@/components/admin/BaseHeader";
import SurveyCreator from "@/components/admin/SurveyCreator";
import DataService from '@/services/data.service';

export default {
  components: {
    SurveyCreator,
    BaseHeader
  },
  data() {
    return {
      survey: {},
    }
  },
  mounted() {
    this.getSurvey(this.$route.params.id);
  },
  methods: {
    getSurvey(id) {
        DataService.showEditor(id).then(res => {
        this.survey = res.data.survey;
      }).catch(error => console.error(error));

    },
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

}

.svd_container .svd_commercial_container{
  display: none!important;
}

</style>
